import { useStore } from '@nanostores/react';
import { Outlet } from '@remix-run/react';
import { ClientOnly } from 'remix-utils/client-only';
import { CreateTeamModal } from '~/components/dialogs/CreateTeamOverlay.client';
import { InviteMembersModal } from '~/components/dialogs/InviteMembersOverlay/InviteMembersOverlay.client';
import { Dialogs } from '~/components/ui/Dialogs.client';
import { FreeTeamBanner } from '~/components/ui/FreeTeamBanner/FreeTeamBanner.client';
import { InvitationBanner } from '~/components/ui/InvitationBanner/InvitationBanner.client';
import { userStore } from '~/lib/stores/user';

export default function ChatLayout() {
  const user = useStore(userStore.user);
  const loggedIn = useStore(userStore.loggedIn);

  return (
    <>
      <Outlet />
      <ClientOnly>
        {() => (
          <>
            {loggedIn && user ? (
              <>
                <CreateTeamModal />
                <InviteMembersModal />
                <FreeTeamBanner user={user} />
                <InvitationBanner user={user} />
                <Dialogs />
              </>
            ) : null}
          </>
        )}
      </ClientOnly>
    </>
  );
}
